import { PaytrieAPI } from '@paytrie/client'

import { generateSessionId } from './generateSessionId'

export type PasswordlessClient = 'widget' | 'gmt'

export type PasswordlessSession = {
  sessionId: string
}

export const startPasswordlessLogin = async ({
  email,
  client,
  referral,
  vendor,
}: {
  email: string
  client: PasswordlessClient
  referral?: string
  vendor?: string
}): Promise<PasswordlessSession> => {
  const sessionId = generateSessionId()

  const response = await PaytrieAPI.requestMagicLink({
    email,
    sessionId,
    client,
    referral,
    vendor,
  })

  if (response.status !== 202) {
    throw new Error(
      `Failed to start passwordless login (status ${response.status})`
    )
  }

  return { sessionId }
}
